import values from 'lodash/values'
import { createSelector } from 'reselect'
import update from 'immutability-helper'

export const PUSH_LOCATION = 'tt/shp/PUSH_LOCATION'
export const PUSH_LOCATIONS = 'tt/shp/PUSH_LOCATIONS'

const initialState = {
  data: {},
}

/* -------------------------------------------------------- REDUCER */

export const reducer = (state = initialState, action) => {
  const actions = {
    [PUSH_LOCATION]: ({ location }) => update(state, {
      data: { [location.id]: { $set: location } },
    }),
    [PUSH_LOCATIONS]: ({ locations }) => update(state, {
      data: { $set: locations.reduce((o, location) => Object.assign(o, { [location.id]: location }), {}) },
    }),
  }
  return actions[action.type] ? actions[action.type](action) : state
}

/* -------------------------------------------------------- ACTIONS */

export const pushLocations = locations => ({
  type: PUSH_LOCATIONS,
  locations,
})

export const pushLocation = location => ({
  type: PUSH_LOCATION,
  location,
})

/* -------------------------------------------------------- SELECTORS */
export const container = state => state.locations

export const makeSelectLocations = () =>
  createSelector(
    container,
    state => state.ids.map(id => state.data[id])
  )

export const makeSelectLocationById = idGetter =>
  createSelector(
    container,
    (_state, props) => idGetter(props),
    (state, id) => state.data[id] || null
  )

export const makeSelectLocationByDateId = idGetter =>
  createSelector(
    container,
    (_state, props) => idGetter(props),
    (state, id) => values(state.data).filter(location => location.event_date_id === id) || null
  )
